import React, { useState, useEffect } from 'react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [clientUrl, setClientUrl] = useState(null);
  const [hotelLogo, setHotelLogo] = useState(null);
  const [hotelName, setHotelName] = useState(null);

  // Load client_url on component mount
  useEffect(() => {
    // First check URL params (in case it's a fresh widget load)
    const searchParams = new URLSearchParams(window.location.search);
    const urlClientUrl = searchParams.get('client_url');
    
    if (urlClientUrl) {
      // Store it in sessionStorage (cleared when browser closes)
      sessionStorage.setItem('client_url', urlClientUrl);
      setClientUrl(urlClientUrl);
      console.log('✅ Stored client_url in sessionStorage:', urlClientUrl);
    } else {
      // Otherwise, get from sessionStorage
      const storedUrl = sessionStorage.getItem('client_url');
      setClientUrl(storedUrl);
    }

    // Load hotel logo from sessionStorage if available
    const storedHotelLogo = sessionStorage.getItem('hotel_logo');
    const storedHotelName = sessionStorage.getItem('hotel_name');
    if (storedHotelLogo) {
      setHotelLogo(storedHotelLogo);
    }
    if (storedHotelName) {
      setHotelName(storedHotelName);
    }
  }, []);

  // Listen for hotel data changes from other components
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'hotel_logo') {
        setHotelLogo(e.newValue);
      }
      if (e.key === 'hotel_name') {
        setHotelName(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also listen for custom events
    const handleHotelDataUpdate = (event) => {
      if (event.detail?.hotelLogo) {
        setHotelLogo(event.detail.hotelLogo);
      }
      if (event.detail?.hotelName) {
        setHotelName(event.detail.hotelName);
      }
    };
    
    window.addEventListener('hotelDataUpdate', handleHotelDataUpdate);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('hotelDataUpdate', handleHotelDataUpdate);
    };
  }, []);

  const handleLogoClick = () => {
    window.location.href = clientUrl;
  };

  const handleHotelPageClick = () => {
    if (clientUrl) {
      window.location.href = clientUrl;
    } else {
      console.log('No client_url found, staying on current page');
    }
  };

  return (
    <header className="w-full top-0 left-0 z-20 bg-white h-auto border-b border-gray-200">
      <div className="container mx-auto px-6 lg:px-8 py-2 h-full flex justify-between items-center">
        <button onClick={handleLogoClick} className="flex items-center gap-3">
          {hotelLogo ? (
            <img 
              src={hotelLogo}
              alt={hotelName || "Hotel Logo"} 
              className="h-14 md:h-20 w-auto object-contain cursor-pointer"
            />
          ) : (
            <img 
              src="https://api.roomstatushub.in/storage/hotel_logos/2026/05/08/69fd7e4f7f2bc_1778220623.jpg"
              alt="TigerInn Comfort Resort Hotels" 
              className="h-14 md:h-20 w-auto object-contain cursor-pointer"
            />
          )}
          
        </button>
        
        <button 
          onClick={handleHotelPageClick}
          disabled={!clientUrl}
          className={`px-4 py-2 text-base font-medium rounded-md transition-colors duration-200 ${
            clientUrl 
              ? 'text-text-secondary hover:bg-gray-100 hover:text-brand-accent cursor-pointer' 
              : 'text-gray-400 cursor-not-allowed'
          }`}
          title={clientUrl ? "Go to hotel website" : "No hotel website available"}
        >
          Hotel page
        </button>
      </div>
      
      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="absolute top-16 left-0 w-full bg-white shadow-lg lg:hidden z-10 border-t border-gray-200">
          <nav className="flex flex-col p-4 space-y-2">
            <button 
              onClick={handleHotelPageClick}
              disabled={!clientUrl}
              className={`block px-4 py-2 text-base font-medium rounded-md transition-colors duration-200 text-left w-full ${
                clientUrl 
                  ? 'text-text-secondary hover:bg-gray-100 hover:text-brand-accent' 
                  : 'text-gray-400 cursor-not-allowed'
              }`}
              title={clientUrl ? "Go to hotel website" : "No hotel website available"}
            >
              Hotel page
            </button>
            <a href="#" className="block px-4 py-2 text-base font-medium text-text-secondary hover:bg-gray-100 hover:text-brand-accent rounded-md transition-colors duration-200">Help</a>
            <a href="#" className="block px-4 py-2 mt-2 text-base font-medium text-text-secondary hover:bg-gray-100 hover:text-brand-accent rounded-md transition-colors duration-200 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              My Account
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;